/** @copy-from https://gitlab.poski.com/poskireal/poskireal.cz/-/blob/07456af8b2b7090b0ed8294c58737da301e2468b/frontend/CID/poski/v5.2/klasik/js/nemovitost.fotogalerie-1.js */
document.addEventListener("DOMContentLoaded", function() {

    // swiper detail nemovitosti - náhledy pod fotografií
    //===================================================
    (function () {
        const galleryWrapper = document.querySelector('.estateImages');
        if (!galleryWrapper) return; // stránka bez .estateImages (např. nemovitost-detail v1) – nepadat
        const slidesCount = getComputedStyle(galleryWrapper).getPropertyValue('--estateImages-slidesCount'),
            slidesSpacing = getComputedStyle(galleryWrapper).getPropertyValue('--estateImages-slidesSpacing');
        let galleryTop, galleryThumbs;

        const swiperTop = document.querySelector('.JS-photo-slider-detail-top');
        if(typeof(swiperTop) != 'undefined' && swiperTop != null){
            galleryTop = new Swiper(swiperTop, {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                loop: true,
                loopedSlides: !!slidesCount ? parseInt(slidesCount) : 4,
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                }
            });
        }

        const swiperBottom = document.querySelector('.JS-photo-slider-detail-bottom');
        if(typeof(swiperBottom) != 'undefined' && swiperBottom != null){
            galleryThumbs = new Swiper(swiperBottom, {
                spaceBetween: !!slidesSpacing ? parseInt(slidesSpacing) : 10,
                slidesPerView: !!slidesCount ? parseInt(slidesCount) : 4,
                slideToClickedSlide: true,
                watchSlidesVisibility: true,
                loop: true,
                loopedSlides: !!slidesCount ? parseInt(slidesCount) : 4,
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                }
            });

            galleryTop.controller.control = galleryThumbs;
            galleryThumbs.controller.control = galleryTop;
        }

        const galleryVideo = document.querySelectorAll('.JS-photo-slider-video');
        if(galleryVideo.length){
            const setFrameHeight = () => {
                galleryVideo.forEach(video => video.style.height = 0);
                const wrapperHeight = galleryVideo[0].closest('.swiper-wrapper').offsetHeight + 'px';
                galleryVideo.forEach(video => video.style.height = wrapperHeight);
            }

            setFrameHeight();
            window.addEventListener('resize',setFrameHeight);
        }
    }());
});